import { Modal } from "react-bootstrap";
import ModifierComboGroupDetailsModifier from "./ModifierComboGroupDetailsModifier.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";

export default function ModifierComboGroupDetailsModalPage(props) {
    // Returns the modal page that contains the modifiers in the selected group within the selected Modifier Combo
    let groupIndex = props.modifierComboDetails.selectedGroupIndex;
    let selectedGroupFormData = props.modifierComboFormData.modComboGroups[groupIndex];
    
    // Error Styling
    let badgeClassStyles = "";
    if (props.errorModifierCombo.GroupDetailsPage.HasError) {
        badgeClassStyles = "wo-req--bad";
    } else {
        badgeClassStyles = "";
    }
    let isDisabled = props.errorModifierCombo.GroupDetailsPage.ButtonsDisabled || !props.currentLocation.AllowOnlineOrder || !props.currentLocation.Validation.IsValidTableNumber;

    // Badge Text
    let chooseAmountText = "";
    if (props.modifierComboDetails.selectedGroupDetails.type === "Radio") { // Note - Can only be radio inside Group within Modifier Combo
        chooseAmountText = `Choose 1`;
    }
    
    const modifiers = props.modifierComboDetails.selectedGroupDetails.mods.map((mod) => {
        let currentObj = ""; // Filtering and passing just the modifier Form Data
        let fieldName = "";
        let isChecked = "";
        
        if (props.modifierComboDetails.selectedGroupDetails.type === "Radio") { // Note - Can only be radio inside Group within Modifier Combo
            fieldName = `RadioModComboModCatId${props.modifierComboDetails.modifierComboDetails.modCategoryId}ModGroupIndex${groupIndex}ModId${mod.modId}`;
            currentObj = selectedGroupFormData.ModsInGroup.find((modInGroup) => {
                return modInGroup.FieldName == fieldName
            })
        }
        
        return (
            <ModifierComboGroupDetailsModifier
                key={mod.modId}
                type={props.modifierComboDetails.selectedGroupDetails.type}
                modifierDetails={mod}
                modifierFormData={currentObj}
                selectedGroupFormData={selectedGroupFormData}
                handleModifierChangeModComboGroup={props.handleModifierChangeModComboGroup}
                isDisabled={isDisabled}
            />
        )
    })

    return (
        <>
            <Modal.Body className="wo-pm__body">
                <div className="wo-pm__intro">
                    <h3 className="wo-pm__name">{props.modifierComboDetails.selectedGroupDetails.modCategoryName}</h3>
                    {props.modifierComboDetails.selectedGroupDetails.modCategoryDescription &&
                        <p className="wo-pm__desc">{props.modifierComboDetails.selectedGroupDetails.modCategoryDescription}</p>}
                </div>
                <div className="wo-pm__options row g-0">
                    <div className="col-12 wo-opt__head">
                        <span className="wo-opt__name">Your choice</span>
                        <span className={`wo-req ${badgeClassStyles}`}>{chooseAmountText}</span>
                    </div>
                    {modifiers}
                </div>
            </Modal.Body>
            <Modal.Footer className="wo-pm__foot">
                { props.errorModifierCombo.GroupDetailsPage.HasError && <div className="wo-pm__footErr"><ErrorAlert message={props.errorModifierCombo.GroupDetailsPage.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                    <div className="wo-pm__footBar">
                        <button type="button" className="wo-pm__add" onClick={props.handleModifierComboAddSelectionToGroup} disabled={props.errorModifierCombo.GroupDetailsPage.ButtonsDisabled}>
                            Add selection to combo
                            { props.errorModifierCombo.GroupDetailsPage.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>
                    </div>
                }
            </Modal.Footer>
        </>
    )
}